import React from "react";
import "./OrangeGradientButton.css";

export default function OrangeGradientButton({ children, onClick }) {
  return (
    <button className="orange-gradient-button" onClick={onClick}>
      <svg
        height="20"
        width="20"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"
          fill="currentColor"
        />
      </svg>
      <span>{children}</span>
    </button>
  );
}
